export default {
  "gatehouse": "Gatehouse",
  "openControlPanel": "Open Control Panel",
  "totalAccess": "Total Access",
  "deniedAccess": "Denied Access",
  "activeAlerts": "Active Alerts",
  "openIncidents": "Open Incidents",
  "highRisk": "High Risk",
  "accessLogHistory": "Access Log History",
  "refresh": "Refresh",
  "export": "Export",
  "searchByMemberNameOrZone": "Search by member name or zone...",
  "status": "Status",
  "allStatus": "All Status",
  "granted": "Granted",
  "denied": "Denied",
  "zone": "Zone",
  "allZones": "All Zones",
  "method": "Method",
  "allMethods": "All Methods",
  "member": "Member",
  "time": "Time",
  "riskLevel": "Risk Level",
  "notes": "Notes",
  "noAccessLogsFoundMatchingYourCriteria": "No access logs found matching your criteria",
  "cameraEventTimeline": "Camera Event Timeline",
  "exportView": "Export View",
  "searchByCameraName": "Search by camera name...",
  "eventType": "Event Type",
  "allEventTypes": "All Event Types",
  "person": "Person",
  "vehicle": "Vehicle",
  "motion": "MOTION",
  "doorbell": "Doorbell",
  "loadingEvents": "Loading events...",
  "noEventsFoundMatchingCriteria": "No events found matching criteria.",
  "eventThumbnail": "Event thumbnail",
  "playback": "Playback",
  "createIncident": "Create Incident",
  "offline": "OFFLINE",
  "loadingCameras": "Loading cameras...",
  "cameraWall": "Camera Wall",
  "grid": "Grid",
  "accessControlScanner": "Access Control Scanner",
  "scanQrCodeRfidOrEnterMembershipNumber": "Scan QR code, RFID, or enter membership number...",
  "clear": "Clear",
  "staffOverride": "Staff Override",
  "gateCameras": "Gate Cameras",
  "recentGateActivity": "Recent Gate Activity",
  "expectedArrivals": "Expected Arrivals",
  "noExpectedArrivalsToday": "No expected arrivals today",
  "quickActions": "Quick Actions",
  "reportIncident": "Report Incident",
  "viewLiveCameras": "View Live Cameras",
  "emergencyOverride": "Emergency Override",
  "incidentManagement": "Incident Management",
  "trackAndManageSecurityIncidentsAndReports": "Track and manage security incidents and reports",
  "searchIncidents": "Search incidents...",
  "severity": "Severity",
  "allSeverity": "All Severity",
  "type": "Type",
  "allTypes": "All Types",
  "view": "View",
  "update": "Update",
  "actionsTaken": "Actions Taken:",
  "witnesses": "Witnesses:",
  "followupRequired": "Follow-up Required",
  "noIncidentsFoundMatchingYourCriteria": "No incidents found matching your criteria",
  "incidentReportingFormWouldBeImplementedHere": "Incident reporting form would be implemented here.",
  "close": "Close",
  "securityAlerts": "Security Alerts",
  "searchAlerts": "Search alerts...",
  "allRisk": "All Risk",
  "alertType": "Alert Type",
  "acknowledge": "Acknowledge",
  "resolve": "Resolve",
  "recommendedAction": "Recommended Action:",
  "resolutionNotes": "Resolution Notes:",
  "noSecurityAlertsFoundMatchingYourCriteria": "No security alerts found matching your criteria",
  "recentAccessActivity": "Recent Access Activity",
  "prioritySecurityAlerts": "Priority Security Alerts",
  "noHighpriorityAlerts": "No high-priority alerts",
  "accessTrends7Days": "Access Trends (7 Days)",
  "zoneAccessDistribution": "Zone Access Distribution",
  "alertRiskLevels": "Alert Risk Levels",
  "zoneStatusOverview": "Zone Status Overview",
  "bookingRequired": "Booking Required",
  "unifiProtectIntegration": "UniFi Protect Integration",
  "connected": "Connected",
  "disconnected": "Disconnected",
  "totalCameras": "Total Cameras",
  "online": "Online",
  "recording": "Recording:",
  "motionAlerts": "Motion Alerts",
  "cameraLocations": "Camera Locations",
  "fullscreen": "Fullscreen",
  "cameraOffline": "Camera Offline",
  "rec": "REC",
  "play": "Play",
  "stop": "Stop",
  "model": "Model:",
  "ipAddress": "IP Address:",
  "nightVision": "Night Vision:",
  "selectACameraToViewLiveFeed": "Select a camera to view live feed",
  "unifiIntegrationSettings": "UniFi Integration Settings",
  "unifiConsoleIp": "UniFi Console IP",
  "username": "Username",
  "apiKey": "API Key",
  "testConnection": "Test Connection",
  "saveSettings": "Save Settings",
  "zoneManagement": "Zone Management",
  "configureAccessPermissionsAndSettingsForDifferentClubZones": "Configure access permissions and settings for different club zones",
  "addZone": "Add Zone",
  "capacity": "Capacity",
  "hours": "Hours",
  "allowedMemberships": "Allowed Memberships",
  "allMembers": "All Members",
  "emergencyOverrideActive": "Emergency Override Active",
  "active": "Active",
  "edit": "Edit",
  "zoneConfigurationFormWouldBeImplementedHere": "Zone configuration form would be implemented here",
  "inactive": "Inactive",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "editZone": "Edit Zone",
  "addNewZone": "Add New Zone",
  "editIncident": "Edit Incident",
  "reportNewIncident": "Report New Incident",
  "scanning": "Scanning...",
  "scan": "Scan",
  "selectCamera": "Select Camera",
  "live": "LIVE",
  "unlimited": "Unlimited",
  "low": "Low",
  "medium": "Medium",
  "high": "High",
  "critical": "Critical",
  "device": "Device: {id}",
  "anomaliesOne": "{count} anomaly",
  "anomaliesOther": "{count} anomalies",
  "accessSummary": "Showing {shown} of {total} access logs",
  "alertsSummary": "Showing {shown} of {total} alerts",
  "incidentsSummary": "Showing {shown} of {total} incidents",
  "grantedCount": "Granted: {count}",
  "deniedCount": "Denied: {count}",
  "activeCount": "Active: {count}",
  "acknowledgedCount": "Acknowledged: {count}",
  "resolvedCount": "Resolved: {count}",
  "openCount": "Open: {count}",
  "investigatingCount": "Investigating: {count}",
  "confidence": "{count}% confidence",
  "acknowledgedBy": "Acknowledged by {name}",
  "reportedBy": "Reported by: {name}",
  "involves": "Involves: {name}",
  "photosOne": "{count} photo attached",
  "photosOther": "{count} photos attached",
  "riskLabel": "{level} risk",
  "severityLabel": "{level} severity",
  "memberIdentity": "{type} Member #{number}",
  "visiting": "Visiting: {name}",
  "host": "Host: {name}",
  "expected": "Expected: {time}",
  "accessGranted": "Access Granted",
  "accessDenied": "Access Denied",
  "capacitySummary": "Capacity: {current}/{max}",
  "accessHours": "Access: {start} - {end}",
  "liveFeed": "Live Feed: {name}",
  "lastMotion": "Last Motion: {time}",
  "validMembership": "Valid membership",
  "inactiveMembership": "Inactive membership",
  "validVisitorPass": "Valid visitor pass",
  "invalidVisitorPass": "Invalid visitor pass",
  "invalidScanCode": "Invalid scan code",
  "systemError": "System error",
  "overrideApproved": "Staff override approved",
  "loadError": "Unable to load Security data. Please try again.",
  "dateUnavailable": "Date unavailable",
  "noCameras": "No cameras available",
  "fullscreenCamera": "View camera fullscreen",
  "pauseCamera": "Pause live view",
  "playCamera": "Play live view",
  "muteCamera": "Mute camera",
  "unmuteCamera": "Unmute camera",
  "eventDate": "Event date",
  "settings": "Settings",
  "accessCount": "Access count",
  "enums": {
    "status": {
      "granted": "granted",
      "denied": "denied",
      "active": "active",
      "inactive": "inactive",
      "acknowledged": "acknowledged",
      "resolved": "resolved",
      "dismissed": "dismissed",
      "open": "open",
      "investigating": "investigating",
      "closed": "closed",
      "online": "online",
      "offline": "offline",
      "maintenance": "maintenance"
    },
    "risk": {
      "low": "low",
      "medium": "medium",
      "high": "high",
      "critical": "critical"
    },
    "severity": {
      "low": "low",
      "medium": "medium",
      "high": "high",
      "critical": "critical"
    },
    "method": {
      "qr_code": "qr code",
      "manual_override": "manual override",
      "rfid": "rfid"
    },
    "event": {
      "person": "person",
      "vehicle": "vehicle",
      "motion": "motion",
      "doorbell": "doorbell"
    }
  },
  "cameraIncidentDescription": "Incident based on {type} detection at {camera}."
};
